"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MenuHeader = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importDefault(require("react"));
const prop_types_1 = __importDefault(require("prop-types"));
const react_jss_1 = __importDefault(require("react-jss"));
const menu_header_style_1 = __importDefault(require("./menu.header.style"));
class MenuHeader extends react_1.default.PureComponent {
    constructor() {
        super(...arguments);
        this.render = () => {
            const { classes, title, action } = this.props;
            if (!title && !action)
                return null;
            return (jsx_runtime_1.jsxs("div", Object.assign({ className: classes.root }, { children: [title && jsx_runtime_1.jsx("div", Object.assign({ className: classes.title }, { children: title }), void 0),
                    action && jsx_runtime_1.jsx("div", Object.assign({ className: classes.action }, { children: action }), void 0)] }), void 0));
        };
    }
}
exports.MenuHeader = MenuHeader;
MenuHeader.propTypes = {
    classes: prop_types_1.default.object.isRequired,
    title: prop_types_1.default.string,
    action: prop_types_1.default.node
};
MenuHeader.defaultProps = {
    title: null,
    action: null
};
exports.default = react_jss_1.default(menu_header_style_1.default)(MenuHeader);
//# sourceMappingURL=menu.header.js.map